import { gql } from "@apollo/client";

export const ADD_BOOKING_PO_NUMBER = gql`
  mutation addBookingPoNumber($bookingId: ID!, $poNumber: String!) {
    addBookingPoNumber(bookingId: $bookingId, poNumber: $poNumber)
  }
`;
